// The `source` a file import stamps on the recording it creates. Live recordings never send
// one — the backend resolves an omitted source as HIIKER — so this is the only place the web
// client tells the server "this track did not come from a HiiKER recording".
export const IMPORTED_RECORDING_SOURCE = 'IMPORTED';

/** What the GPX/FIT parsers in ImportRecordingDialog hand back for one file. */
export interface ImportedTrackData {
  title?: string;
  lineString?: string;
  elapsedSeconds?: number;
  timeStamps?: number[];
  altitudes?: number[];
  hAccuracies?: number[];
  speeds?: number[];
  courses?: number[];
  createdAt?: string;
}

/**
 * Builds the `CreateRecordingInput` for an imported track. Pure so the shape the server
 * receives — and in particular that every import carries `source: IMPORTED` — can be pinned
 * by a unit test without a DOM or a GraphQL client.
 */
export function buildImportRecordingInput(
  trackData: ImportedTrackData,
  clientId: string,
  fallbackCreatedAt: string
) {
  return {
    lineString: trackData.lineString || '',
    elapsedSeconds: trackData.elapsedSeconds || 0,
    timeStamps: trackData.timeStamps || [],
    altitudeData: trackData.altitudes?.join(',') || '',
    courseAccuracy: [],
    speedAccuracy: [],
    verticalAccuracy: [],
    horizontalAccuracy: trackData.hAccuracies || [],
    speed: trackData.speeds || [],
    course: trackData.courses || [],
    clientId,
    createdAt: trackData.createdAt || fallbackCreatedAt,
    title: trackData.title,
    source: IMPORTED_RECORDING_SOURCE,
  };
}
